var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlotaBlockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DA0D29",
    d: "M30 15.5a15 15 0 1 1-30 0 15 15 0 0 1 30 0ZM15 8a1.697 1.697 0 0 0-1.688 1.866l.657 6.575a1.035 1.035 0 0 0 2.062 0l.657-6.575A1.696 1.696 0 0 0 15 8Zm.004 11.25a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z",
    transform: "translate(0 .5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlotaBlockIcon);
export default __webpack_public_path__ + "static/media/flota-block-icon.d56fd78b2c80fb0c7f7cdac8b283ba2d.svg";
export { ForwardRef as ReactComponent };